import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";
import {CPageHeight} from "./pageheight";
import {CPageWidth} from "./pagewidth";

export class CPageSetup extends BasicCPCLArg<CPageSetup> {
  private pageHeight: number;
  private pageWidth: number;

  constructor(options?: {
    pageHeight?: number
    pageWidth?: number
  }) {
    super();
    this.pageHeight = options?.pageHeight ?? 0;
    this.pageWidth = options?.pageHeight ?? 0;
  }

  clause(): CommandClause {
    super.prepend(new CPageHeight({height: this.pageHeight}));
    super.append(new CPageWidth({width: this.pageWidth}));
    return CPCLCommand.with(this.header()).clause();
  }

  header(): string {
    return '';
  }
}



